// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}




/* Prevent page scroll when interacting with map */
.leaflet-container {
  touch-action: none;
  -webkit-tap-highlight-color: transparent;
}

/* Disable body scroll when map is active */
body.map-interacting {
  overflow: hidden;
}

/* Ensure map container doesn't cause scroll */
.leaflet-pane,
.leaflet-top,
.leaflet-bottom,
.leaflet-control {
  z-index: 1;
}







`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;;;;AAKA,kDAAkD;AAClD;EACE,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA,2CAA2C;AAC3C;EACE,gBAAgB;AAClB;;AAEA,8CAA8C;AAC9C;;;;EAIE,UAAU;AACZ","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n\n\n\n/* Prevent page scroll when interacting with map */\n.leaflet-container {\n  touch-action: none;\n  -webkit-tap-highlight-color: transparent;\n}\n\n/* Disable body scroll when map is active */\nbody.map-interacting {\n  overflow: hidden;\n}\n\n/* Ensure map container doesn't cause scroll */\n.leaflet-pane,\n.leaflet-top,\n.leaflet-bottom,\n.leaflet-control {\n  z-index: 1;\n}\n\n\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
